import React, { FunctionComponent } from 'react';
import { Stepper, StepperStep } from '../../../../shared/general';
import { CalculatorBuyerCostsStepperStep1, CalculatorBuyerCostsStepperStep2 } from './steps';
import { useFormContext } from '../../../../../hooks';
import { CalculatorBuyerCostsFormFields, CalculatorBuyerCostsResultData } from '../types';
import { useIntl } from 'react-intl';

interface StepsArray {
  component: FunctionComponent<{ id: number; title?: string }>;
  hide: boolean;
  title?: string;
}

export const CalculatorBuyerCostsStepper = () => {
  const intl = useIntl();
  const { form } = useFormContext<CalculatorBuyerCostsResultData, CalculatorBuyerCostsFormFields>();
  const step1Title = intl.formatMessage({ id: 'step1.title', defaultMessage: 'Koopsom woning' });
  const step2Title = intl.formatMessage({ id: 'step2.title', defaultMessage: 'Verder rekenen' });

  const steps: StepsArray[] = [
    {
      component: CalculatorBuyerCostsStepperStep1,
      hide: false,
      title: step1Title
    },
    {
      component: CalculatorBuyerCostsStepperStep2,
      hide: form.isNewConstruction === 'true' || !form.isNewConstruction ? true : false,
      title: step2Title
    }
  ];

  return (
    <Stepper previousButtonTexts={[step1Title, step2Title]}>
      {steps &&
        steps.map((step, key) => (
          <StepperStep id={key} hide={step.hide} key={key}>
            <step.component id={key} title={step.title} />
          </StepperStep>
        ))}
    </Stepper>
  );
};
